import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';

export class DynamicFormModalResponse {
  constructor(
    public formData: any,
    public formValid: any,
    public updatedFields: string[],
    public responseType: modalResponse
  ) { }
}
